import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useDirectDealsPublisherDetails } from '../../../utils/context/DirectDealsPublisherDetailsContext.tsx';

type CountriesCardProps = {
  title: string;
};

export const CountriesCard = ({ title }: CountriesCardProps) => {
  const publisherDetails = useDirectDealsPublisherDetails();

  if (!publisherDetails?.top_countries || publisherDetails.top_countries.length === 0) {
    return null;
  }

  return (
    <Box
      data-test="top-countries"
      sx={{
        border: 1,
        padding: 3,
        borderColor: 'divider',
        marginTop: 4,
      }}
    >
      <Box
        sx={{
          paddingBottom: 1,
          borderBottom: 1,
          marginBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Typography variant="h3">{title}</Typography>
      </Box>
      <Grid
        container
        sx={{
          paddingTop: 1,
          width: 1,
        }}
      >
        {publisherDetails.top_countries.map(country => (
          <Grid size={6} key={country}>
            <Typography variant="body1">{country}</Typography>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
